import { type TabItem } from '@/features/products/utils/tabs';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

interface TabPanelsProps {
  tabs: TabItem[];
  activeIndex: number;
  /**
   * Anonymous visitors get every panel in the initial HTML so crawlers index the tab content;
   * logged-in users keep the lighter render that only mounts the panel they are looking at.
   */
  renderAll: boolean;
}

export const TabPanels = ({ tabs, activeIndex, renderAll }: TabPanelsProps) => (
  <>
    {tabs.map(({ label, content }, index) => {
      const isActive = index === activeIndex;

      if (!renderAll && !isActive) {
        return null;
      }

      return (
        <Box key={label} role="tabpanel" hidden={!isActive}>
          {content}
        </Box>
      );
    })}
  </>
);
